import { createSlice } from "@reduxjs/toolkit";
import {
  loginThunk,
  registerThunk,
  logoutThunk,
  forgetPasswordThunk,
  resetPasswordThunk,
  getCompanyByUserHasRegisteredThunk,
  fillBiodataThunk,
  changePasswordThunk,
} from "state/action/auth";

// Initial state
const initialState = {
  // note: login inisial state
  login_input: {
    email: "",
    password: "",
  },
  // note: login
  login: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: logout
  logout: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: register inisial state
  register_step: {
    step: 0,
    isComplated: false,
  },
  register_input: {
    fullname: "",
    email: "",
    password: "",
  },
  register: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: fill biodata input
  fill_biodata_input: {
    name: "",
  },
  fillBiodata: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: forgot password
  forgot_email_input: {
    email: "",
  },
  forgetPassword: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  changePassword: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: get company by user has registered
  getCompanyByUserHasRegistered: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // note: reset password
  reset_password_input: {
    password: "",
  },
  resetPassword: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  change_password_input: {
    new_password: "",
    current_password: "",
  },
  // note: verify register code
  verify_register_code_input: {
    otp: "",
  },
  utils: {
    whatIsBimaVisible: false,
  },
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // note: Reducer login
    setLoginInput: (state, action) => {
      return {
        ...state,
        login_input: action.payload.login_input,
      };
    },
    setUtils: (state, action) => {
      return {
        ...state,
        utils: action.payload,
      };
    },
    setChangePasswordInputBody: (state, action) => {
      return {
        ...state,
        change_password_input: action.payload,
      };
    },
    // note: clear
    setClearLogin: (state, _) => {
      return {
        ...state,
        login: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearLogout: (state, _) => {
      return {
        ...state,
        logout: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    // note: Reducer role
    setRoleInput: (state, action) => {
      return {
        ...state,
        role_input: action.payload.role_input,
      };
    },
    setRole: (state, action) => {
      return {
        ...state,
        role: action.payload.role,
      };
    },
    // note: Reducer register
    setRegisterInput: (state, action) => {
      return {
        ...state,
        register_input: action.payload.register_input,
      };
    },
    setRegisterDataToLogin: (state, action) => {
      return {
        ...state,
        login: {
          data: action.payload,
          isPending: false,
          isFulfilled: true,
          isRejected: false,
          err: null,
        },
      };
    },
    setRegisterStep: (state, action) => {
      return {
        ...state,
        register_step: action.payload,
      };
    },
    setFillBodataInput: (state, action) => {
      return {
        ...state,
        fill_biodata_input: action.payload,
      };
    },
    // note: Reducer verify Account
    setVerifyRegisterCodeInput: (state, action) => {
      return {
        ...state,
        verify_register_code_input: action.payload,
      };
    },
    setClearVerifyRegisterCodeInput: (state, _) => {
      return {
        ...state,
        verify_register_code_input: {
          otp: "",
        },
      };
    },
    setClearChangePasswordInput: (state, _) => {
      return {
        ...state,
        change_password_input: {
          current_password: "",
          new_password: "",
        },
      };
    },
    // note: Reducer forget password
    setForgetEmailInput: (state, action) => {
      return {
        ...state,
        forgot_email_input: action.payload,
      };
    },
    setClearForgetEmailInput: (state, _) => {
      return {
        ...state,
        forgot_email_input: {
          email: "",
        },
      };
    },
    setClearForgetPassword: (state, _) => {
      return {
        ...state,
        forgetPassword: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    // note: Reducer reset password
    setResetPasswordInput: (state, action) => {
      return {
        ...state,
        reset_password_input: action.payload,
      };
    },
    setClearResetPasswordInput: (state, _) => {
      return {
        ...state,
        reset_password_input: {
          password: "",
        },
      };
    },
    setClearResetPassword: (state, _) => {
      return {
        ...state,
        resetPassword: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    // note: clear register
    setClearRegister: (state, _) => {
      return {
        ...state,
        register: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearRegisterInput: (state, _) => {
      return {
        ...state,
        register_input: {
          email: "",
          password: "",
        },
      };
    },
    setClearStep: (state, _) => {
      return {
        ...state,
        register_step: {
          step: 0,
          isComplated: false,
        },
      };
    },
    setClearFillBiodataInput: (state, _) => {
      return {
        ...state,
        fill_biodata_input: {
          name: "",
        },
      };
    },
    setClearFillBiodata: (state, _) => {
      return {
        ...state,
        fillBiodata: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllAuthState: (state, _) => {
      return {
        ...state,
        login: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // note: register inisial state
        register_step: {
          step: 0,
          isComplated: false,
        },
        register_input: {
          email: "",
          password: "",
        },
        register: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // note: fill biodata input
        fill_biodata_input: {
          name: "",
        },
        fillBiodata: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // note: forgot password
        forgot_email_input: {
          email: "",
        },
        forgetPassword: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // resetPassword: {
        //   data: null,
        //   isFulfilled: false,
        //   isPending: false,
        //   isRejected: false,
        //   err: null,
        // },

        // note: reset password
        reset_password_input: {
          password: "",
        },
        // note: verify register code
        verify_register_code_input: {
          otp: "",
        },
        utils: {
          whatIsBimaVisible: false,
        },
        logout: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
  },
  extraReducers(builder) {
    builder
      // note: login reducer
      .addCase(loginThunk.pending, (state, _) => {
        return {
          ...state,
          login: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        return {
          ...state,
          login: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(loginThunk.rejected, (state, action) => {
        return {
          ...state,
          login: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err:
              action.error?.message ||
              "Email atau password salah. Silakan coba lagi.",
          },
        };
      })
      // note: logout reducer
      .addCase(logoutThunk.pending, (state, _) => {
        return {
          ...state,
          logout: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(logoutThunk.fulfilled, (state, action) => {
        return {
          ...state,
          logout: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(logoutThunk.rejected, (state, action) => {
        return {
          ...state,
          logout: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: register reducer
      .addCase(registerThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(registerThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(registerThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Forget password reducer
      .addCase(forgetPasswordThunk.pending, (state, _) => {
        return {
          ...state,
          forgetPassword: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(forgetPasswordThunk.fulfilled, (state, action) => {
        return {
          ...state,
          forgetPassword: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(forgetPasswordThunk.rejected, (state, action) => {
        return {
          ...state,
          forgetPassword: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Reset password reducer
      .addCase(resetPasswordThunk.pending, (state, _) => {
        return {
          ...state,
          resetPassword: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(resetPasswordThunk.fulfilled, (state, action) => {
        return {
          ...state,
          resetPassword: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(resetPasswordThunk.rejected, (state, action) => {
        return {
          ...state,
          resetPassword: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // note: fill biodata
      .addCase(fillBiodataThunk.pending, (state, _) => {
        return {
          ...state,
          fillBiodata: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(fillBiodataThunk.fulfilled, (state, action) => {
        return {
          ...state,
          fillBiodata: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(fillBiodataThunk.rejected, (state, action) => {
        return {
          ...state,
          fillBiodata: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      .addCase(changePasswordThunk.pending, (state, _) => {
        return {
          ...state,
          changePassword: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(changePasswordThunk.fulfilled, (state, action) => {
        return {
          ...state,
          changePassword: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(changePasswordThunk.rejected, (state, action) => {
        return {
          ...state,
          changePassword: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const authAction = {
  ...authSlice.actions,
  loginThunk,
  registerThunk,
  logoutThunk,
  forgetPasswordThunk,
  resetPasswordThunk,
  changePasswordThunk,
  fillBiodataThunk,
};

// auth : it's got by property of CombineSlice
export function selectLoginInput(state) {
  return state?.auth?.login_input;
}

export function selectRoleInput(state) {
  return state?.auth?.role_input;
}

export function selectRegister(state) {
  return state?.auth?.register;
}

export function selectRegisterInput(state) {
  return state?.auth?.register_input;
}

export function selectRegisterStep(state) {
  return state?.auth?.register_step;
}

export function selectVerifyRegisterCodeInput(state) {
  return state?.auth?.verify_register_code_input;
}

// note: login, register, logout, role selector
export function selectAuth(state) {
  return state?.auth;
}

// note: utils
export function selectAuthUtil(state) {
  return state?.auth?.utils;
}

export default authSlice.reducer;
